import { marked } from "marked";
import { ConversationType } from "../enums/conversation-type";
import { Message, MessagePayload } from '../models/message.model';

export function convertMessageEventToMessage(messageEvent: any): Message {
    const entry = messageEvent.conversationEntry;
    const id = entry.identifier;
    const msgPayload: MessagePayload = JSON.parse(entry.entryPayload);
    let text = '';
    if (msgPayload.abstractMessage && msgPayload.abstractMessage.staticContent) {
        text = msgPayload.abstractMessage.staticContent.text;
    }
    const type = msgPayload.entryType;
    const conversationType = Object.values(ConversationType).find(t => t === type)

    return {
        id,
        text,
        sender: entry.senderDisplayName,
        role: entry.sender.role,
        isOwnMessage: false,
        isError: false,
        timestamp: entry.transcriptedTimestamp,
        conversationType
    }

}

export function convertMessageToUserMessage(msg: string | null): Message {
    if (!msg) {
        throw new Error('Message cannot be empty or null');
    }
    return {
      id: crypto.randomUUID(),
      text: msg.trim(),
      timestamp: new Date(),
      isOwnMessage: true,
      isError: false,
      sender: 'User',
      role:'user'
    }
}

export const openNewWindowRender = {
  link(argsTokens:any) {
    // Call the original link renderer to keep default behavior (like rendering images in links)
    const originalLink = marked.Renderer.prototype.link.call(this, argsTokens);
    
    // Replace the opening <a> tag to include target="_blank" and security rel="noopener noreferrer"
    return originalLink.replace('<a', '<a target="_blank" rel="noopener noreferrer"');
  }
};
